import type { TFunction } from 'i18next'

export function getRoundLabel(roundNumber: number, totalRounds: number, t: TFunction): string {
  if (roundNumber === 0) {
    return t('knockout.round.bronzeMedal', 'Bronze Medal Match')
  }

  if (roundNumber === 1) {
    return t('knockout.round.final', 'Final')
  }

  if (roundNumber === 2) {
    return t('knockout.round.semifinals', 'Semifinals')
  }

  if (roundNumber === 3) {
    return t('knockout.round.quarterfinals', 'Quarterfinals')
  }

  const playersInRound = Math.pow(2, roundNumber)
  if (playersInRound >= 16) {
    return t('knockout.round.roundOf', { count: playersInRound })
  }

  const roundIndexFromStart = totalRounds - roundNumber + 1
  return t('knockout.round.generic', { number: roundIndexFromStart })
}
